"use client";

import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    h7: React.CSSProperties;
    subtitle3: React.CSSProperties;
    body3: React.CSSProperties;
    body4: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h7?: React.CSSProperties;
    subtitle3?: React.CSSProperties;
    body3?: React.CSSProperties;
    body4?: React.CSSProperties;
  }
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    h7: true;
    subtitle3: true;
    body3: true;
    body4: true;
  }
}

declare module "@mui/material/styles" {
  interface CommonColors {
    lightGray: string;
    purple: string;
    silver: string;
    pinkToned: string;
  }
}

export const theme = createTheme({
  palette: {
    primary: { main: "#D05875", contrastText: "#FFFFFF" },
    secondary: { main: "#874893", contrastText: "#FFFFFF" },
    // error: { main: "#f44336" },
    warning: { main: "#F26722" },
    // info: { main: "#2196f3" },
    success: { main: "#22C55E" },
    background: {
      default: "#FFFFFF",
      paper: "#E5E7EB",
    },
    text: {
      primary: "#0F172A",
      secondary: "#808FAE",
      // disabled: "#B4BDCB",
      disabled: "#767580",
    },
    common: {
      black: "#000000",
      white: "#F8F8F8",
      lightGray: "#F2F2F7",
      purple: "#694B9D",
      silver: "#64748B",
      pinkToned: "#82686E",
    },
  },
  spacing: 8,

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1536,
    },
  },

  typography: {
    fontFamily: "var(--font-inter)",
    htmlFontSize: 16,

    h1: { fontSize: "32px", fontWeight: 700 },
    h2: { fontSize: "30px", fontWeight: 700 },
    h3: { fontSize: "24px", fontWeight: 700 },
    h4: { fontSize: "24px", fontWeight: 600 },
    h5: { fontSize: "20px", fontWeight: 600 },
    h6: { fontSize: "20px", fontWeight: 600 },
    h7: { fontSize: "18px", fontWeight: 700 },

    body1: { fontSize: "16px", fontWeight: 500 },
    body2: { fontSize: "14px", fontWeight: 700 },
    body3: { fontSize: "14px", fontWeight: 500 },
    body4: { fontSize: "14px", fontWeight: 400 },

    subtitle1: { fontSize: "13px", fontWeight: 400 },
    subtitle2: { fontSize: "12px", fontWeight: 500 },
    subtitle3: { fontSize: "12px", fontWeight: 400 },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          "@media (max-width:900px)": {
            paddingLeft: "24px !important",
            paddingRight: "24px !important",
          },
          "@media (max-width:600px)": {
            paddingLeft: "12px !important",
            paddingRight: "12px !important",
          },
        },
      },
    },
  },
});
